import axiosInstance from "../utils/axios";

export const getAllResource = async (data) => {
    return await axiosInstance().post(`/getAllResource`, data);
};

export const getStudentLibraryDropdown = async (data) => {
    return await axiosInstance().get(`/getStudentLibraryDropdown`);
}